import { render, staticRenderFns } from "./DeptlistConfirm.vue?vue&type=template&id=0aa7af74&"
import script from "./DeptlistConfirm.vue?vue&type=script&lang=js&"
export * from "./DeptlistConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports